var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedbackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 7.0835H13.75M6.25 10.4168H10.8333",
    stroke: "#626262",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3332 8.75016C18.3332 8.10784 18.3219 7.48082 18.3006 6.87541C18.2308 4.89752 18.1959 3.90857 17.3914 3.09804C16.587 2.2875 15.5701 2.244 13.5363 2.15699C12.4205 2.10925 11.2324 2.0835 9.99984 2.0835C8.76725 2.0835 7.57915 2.10925 6.46334 2.15699C4.42959 2.244 3.41271 2.2875 2.60823 3.09804C1.80375 3.90857 1.76885 4.89752 1.69908 6.87541C1.67772 7.48082 1.6665 8.10784 1.6665 8.75016C1.6665 9.3925 1.67772 10.0195 1.69908 10.6249C1.76885 12.6028 1.80375 13.5917 2.60823 14.4023C3.41271 15.2128 4.42961 15.2563 6.46342 15.3433C7.075 15.3695 7.7083 15.3891 8.35875 15.4014C8.97634 15.4131 9.28517 15.419 9.5565 15.5223C9.82784 15.6257 10.0561 15.8214 10.5128 16.2129L12.329 17.7703C12.4393 17.8648 12.5797 17.9168 12.7249 17.9168C13.0608 17.9168 13.3332 17.6445 13.3332 17.3086V15.3517C13.4012 15.349 13.4689 15.3462 13.5363 15.3433C15.5701 15.2563 16.587 15.2128 17.3914 14.4022C18.1959 13.5917 18.2308 12.6028 18.3006 10.6249C18.3219 10.0195 18.3332 9.3925 18.3332 8.75016Z",
    stroke: "#626262",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackIcon);
export default __webpack_public_path__ + "static/media/feedback-icon.b06d1aa6789690fcbdbe83b61cc249e6.svg";
export { ForwardRef as ReactComponent };